module.exports = __webpack_public_path__ + "static/media/popup-chat-calendar.4a78d98f.svg";